import {URL_BASE_API } from '../../../configs/urlConfigs'; 

import service from '../../api';

export const ppSettingsList = (request) => {
    let ENDPOINT = '';
    ENDPOINT = URL_BASE_API+'super-admin/omnu-points/';
    return service.get(ENDPOINT);    
}; 

export const ppSettingsAdd = (request) => {
  const ENDPOINT = URL_BASE_API+'super-admin/omnu-points/';
  return service.post(ENDPOINT,request.data);  
};  

export const ppSettingsEdit = (request) => {
    let payId = request.data;
    const ENDPOINT = URL_BASE_API+'super-admin/omnu-point/'+payId;
    return service.get(ENDPOINT,request.data);
};

export const ppSettingsUpdate = (request) => {
  let payId = request.data.payId;
  const ENDPOINT = URL_BASE_API+'super-admin/omnu-point/'+payId;
  delete request.data.payId;
  return service.put(ENDPOINT,request.data);
};

export const ppSettingsDelete = (request) => {
  const ENDPOINT = URL_BASE_API+'super-admin/omnu-point/'+request.data;
  return service.delete(ENDPOINT);  
};  
